export const DIGITAL_SERVICE_PROVIDERS = {
  soundcloud: 'SoundCloud',
  spotify: 'Spotify',
  'apple-music': 'Apple Music',
  apple_music: 'Apple Music',
  beatport: 'Beatport'
} as const;
